// src/utils/menu/filterUtils.js

/**
 * Filter processing utilities for menu
 */

/**
 * Check if a filter is active (different from base menu filter)
 */
export const isFilterActive = (filterKey, filterValue, baseMenuFilter) => {
    if (filterKey === 'specials' || filterKey === 'custom_section' || filterKey === 'staff_picks') {
        return Boolean(filterValue);
    }
    
    if (Array.isArray(filterValue)) {
        const baseValue = baseMenuFilter[filterKey];
        return filterValue.length > 0 && 
               (!Array.isArray(baseValue) || filterValue.length !== baseValue.length);
    }
    
    if (typeof filterValue === 'object' && filterValue !== null) {
        return JSON.stringify(filterValue) !== JSON.stringify(baseMenuFilter[filterKey]);
    }
    
    return filterValue !== baseMenuFilter[filterKey];
};

/**
 * Count active filters
 */
export const countActiveFilters = (selectedFilters, baseMenuFilter) => {
    return Object.keys(selectedFilters).reduce((count, key) => {
        return count + (isFilterActive(key, selectedFilters[key], baseMenuFilter) ? 1 : 0);
    }, 0);
};

/**
 * Reset filters to base menu filter
 */
export const resetFilters = (baseMenuFilter) => {
    return { ...baseMenuFilter };
};

/**
 * Apply search parameters to filters
 */
export const applySearchParamsToFilters = (filters, searchQuery, thcMin) => {
    const updatedFilters = { ...filters };
    
    if (searchQuery) {
        updatedFilters.search = searchQuery;
    }
    
    if (thcMin) {
        updatedFilters.potencyThc = {
            ...(updatedFilters.potencyThc || {}),
            min: parseFloat(thcMin)
        };
    }
    
    return updatedFilters;
};

/**
 * Remove empty filter values
 */
export const cleanEmptyFilters = (filters) => {
    const cleaned = {};
    
    Object.entries(filters).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
            cleaned[key] = value;
        } else if (typeof value === 'object' && value !== null && Object.keys(value).length > 0) {
            cleaned[key] = value;
        } else if (value !== null && value !== undefined && value !== '') {
            cleaned[key] = value;
        }
    });
    
    return cleaned;
};

/**
 * Merge filter updates with existing filters
 */
export const mergeFilters = (currentFilters, updates) => {
    return { ...currentFilters, ...updates };
};

/**
 * Check if filters match
 */
export const filtersMatch = (filters1, filters2) => {
    const keys1 = Object.keys(filters1);
    const keys2 = Object.keys(filters2);
    
    if (keys1.length !== keys2.length) return false;
    
    return keys1.every(key => {
        const val1 = filters1[key];
        const val2 = filters2[key];
        
        if (Array.isArray(val1) && Array.isArray(val2)) {
            return val1.length === val2.length && 
                   val1.every((v, i) => v === val2[i]);
        }
        
        if (typeof val1 === 'object' && typeof val2 === 'object') {
            return JSON.stringify(val1) === JSON.stringify(val2);
        }
        
        return val1 === val2;
    });
};
